/* global window */
const supportSessionStorage = () => {
    try {
        return typeof window !== 'undefined' && window.sessionStorage;
    }
    catch (error) {
        return false;
    }
};

const setItem = (key, value) => {
    if (supportSessionStorage() && key) {
        window.sessionStorage.setItem(key, value);
    }
};

const getItem = key => {
    if (supportSessionStorage() && key) {
        return window.sessionStorage.getItem(key);
    }
    return null;
};

const removeItem = key => {
    if (supportSessionStorage() && key) {
        window.sessionStorage.removeItem(key);
    }
};

export {
    supportSessionStorage,
    setItem,
    getItem,
    removeItem
};
